import subtaskAddButtonUrl from './subtaskAddButton.html';

export default {
  templateUrl: subtaskAddButtonUrl,
  controllerAs: 'ctrl',
  bindings: {
    onAdd: '&',
  },
};
